// extracted by extract-css-chunks-webpack-plugin
module.exports = {"split-flap":"Dh7jcAs1Z9nkuBfY14Y1","comma":"a991JGgvJFtDEncG27ar","period":"pJ_F7wdGQilBaNgLJPZ4","card":"ESGZU6Gfuc0QRAyc8ywF"};